import brexLogo from '../assets/images/marketplace/brex-logo.png';
import brexFeature from '../assets/images/marketplace/brex-feature.png';
import comingSoonLogo from '../assets/images/marketplace/coming-soon-logo.png';
import comingSoonFeature from '../assets/images/marketplace/coming-soon-feature.png';
import dreamHostLogo from '../assets/images/marketplace/dream-host-logo.svg';
import dreamHostFeature from '../assets/images/marketplace/dream-host-feature.png';
import fairFigureLogo from '../assets/images/marketplace/fair-figure-logo.svg';
import fairFigureFeature from '../assets/images/marketplace/fair-figure-feature.png';
import growegyFundingConsultationLogo from '../assets/images/marketplace/growegy-funding-consultation-logo.png';
import growegyFundingConsultationFeature from '../assets/images/marketplace/growegy-funding-consultation-feature.png';
import growegyMarketingServicesLogo from '../assets/images/marketplace/growegy-marketing-services-logo.png';
import growegyMarketingServicesFeature from '../assets/images/marketplace/growegy-marketing-services-feature.png';
import growegy1On1ConsultationLogo from '../assets/images/marketplace/growegy-1-on-1-consultation-logo.jpg';
import growegy1On1ConsultationFeature from '../assets/images/marketplace/growegy-1-on-1-consultation-feature.png';
import growegyPromoProductsLogo from '../assets/images/marketplace/growegy-promotional-products-logo.png';
import growegyPromoProductsFeature from '../assets/images/marketplace/growegy-promotional-products.png';
import jungleScoutLogo from '../assets/images/marketplace/jungle-scout-logo.svg';
import jungleScoutFeature from '../assets/images/marketplace/jungle-scout-feature.png';
import navLogo from '../assets/images/marketplace/nav-logo.png';
import navFeature from '../assets/images/marketplace/nav-feature.png';
import quickbooksLogo from '../assets/images/marketplace/quickbooks-logo.svg';
import quickbooksFeature from '../assets/images/marketplace/quickbooks-feature.png';
import tailorBrandsLogo from '../assets/images/marketplace/tailor-brands-logo.png';
import tailorBrandsFeature from '../assets/images/marketplace/tailor-brands-feature.png';
import googleWorkspaceLogo from '../assets/images/marketplace/google-workspace-logo.svg';
import googleWorkspaceFeature from '../assets/images/marketplace/google-workspace-features-2.svg';
import { nonBreakableSpace } from '../util/utils';
import moment from 'moment';
import { fundingConfig } from '../commons/config';

export type ExternalUrl = string | { type: 'calendly'; baseUrl: string };

export type Referral = {
  code: string;
  name: string;
  showName?: boolean;
  pitch: string;
  descriptionMarkdown: string;
  logo: string;
  featureImage?: string;
  url?: ExternalUrl;
  hidden?: boolean;
  buttonText?: string;
  new?: boolean;
};

const MARKETPLACE_REFERRALS: Referral[] = [
  {
    code: 'brex',
    name: 'Brex',
    pitch: '**Get a $250 gift card** when you sign up and spend first $1,000 with Brex.',
    descriptionMarkdown: `
Get all in one scalable solution
* Business banking 
* Card 
* Bill pay
* Travel
* Reimbursements`,
    logo: brexLogo,
    featureImage: brexFeature,
    url: 'https://brex.com/signup?rc=PGY83Pg',
  },
  {
    code: 'dream_host',
    name: 'DreamHost',
    pitch:
      'DreamHost makes sure your website is fast, secure & always up - so your visitors & search engines trust you.',
    descriptionMarkdown: `
* Host your website
* Website builder
* Find your domain name
* Email hosting and${nonBreakableSpace}more!`,
    logo: dreamHostLogo,
    featureImage: dreamHostFeature,
    url: 'http://click.dreamhost.com/aff_c?offer_id=8&aff_id=19603',
  },
  {
    code: 'fair_figure',
    name: 'FairFigure',
    pitch: 'Get funded, monitor and build business credit with FairFigure.',
    descriptionMarkdown: `
* Fund your business with the FairFigure Card
* Build your business credit rating
* Monitor your business credit (Equifax, Experian, Creditsafe, FairFigure)`,
    logo: fairFigureLogo,
    featureImage: fairFigureFeature,
    url: 'https://fairfigure.com?fpr=growfunds',
  },
  {
    code: 'growegy_funding_consultation',
    name: 'Funding Consultation',
    pitch:
      'Schedule a free consultation to find the best **funding options** for your business through our network of trusted lending partners. Eligibility:',
    descriptionMarkdown: `
* Good business credit (no late payments for 12 months)
* 650+ personal credit
* Business tax return from ${moment().subtract(2, 'years').format('YYYY')}
* Current Profit & Loss and Bank Statements`,
    logo: growegyFundingConsultationLogo,
    featureImage: growegyFundingConsultationFeature,
    url: { type: 'calendly', baseUrl: fundingConfig.fundingConsultationUrl },
    buttonText: 'Schedule',
  },
  {
    code: 'growegy_1_1_consultation',
    name: '1-on-1 Consultation',
    pitch:
      'This is a 20-minute paid consultation for $30 (Net 30). We’ll cover topics of your choice during our session. For example,',
    descriptionMarkdown: `
* Review marketing plans and assets
* Assist you with setting up your social medias
* Set and implement goals within Growegy, perform demonstrations and${nonBreakableSpace}more!`,
    logo: growegy1On1ConsultationLogo,
    featureImage: growegy1On1ConsultationFeature,
    url: {
      type: 'calendly',
      baseUrl: 'https://calendly.com/marietwist/video-conference-one-on-one-marketplace',
    },
    buttonText: 'Schedule',
  },
  {
    code: 'growegy_marketing_services',
    name: 'Growegy - Marketing Services',
    pitch:
      "Maximize growth with Growegy's digital marketing services. We offer tailored agency solutions to promote your brand and boost your credit.",
    descriptionMarkdown: `
* Advertising, SEM, PPC, Paid Social
* Website & SEO
* Creative & Content and${nonBreakableSpace}more!`,
    logo: growegyMarketingServicesLogo,
    featureImage: growegyMarketingServicesFeature,
    url: {
      type: 'calendly',
      baseUrl: 'https://calendly.com/marietwist/growegy-small-business-agency-services',
    },
    buttonText: 'Free Assessment',
  },
  {
    code: 'growegy_promotional_products',
    name: 'Growegy Promo Products',
    pitch:
      'Custom promotional products to enhance your brand identity. **50% off sale** on engraved metal business cards and stainless steel bottle openers.',
    descriptionMarkdown: `
* Metal Business Cards & Bottle Openers
* Customizable with your branding
* Net 30 payment terms, will increase credit limit for current account holders`,
    logo: growegyPromoProductsLogo,
    featureImage: growegyPromoProductsFeature,
    url: 'https://www.growegy.com/business-products/',
    buttonText: 'Shop Now',
    hidden: true,
  },
  {
    code: 'jungle_scout',
    name: 'Jungle Scout',
    pitch: `Jungle Scout makes Amazon sellers more successful by providing actionable insights and intelligence.
**Join today and save up to 20%.**`,
    descriptionMarkdown: `
* Discover profitable product opportunities through data-driven insights
* Rank higher on search results and boost organic conversions`,
    logo: jungleScoutLogo,
    featureImage: jungleScoutFeature,
    url: 'https://get.junglescout.com/v9auyico4lz6',
  },
  {
    code: 'nav',
    name: 'Nav',
    pitch: `Get the funding your deserve with Nav. Understand the factors that vendors, lenders, and partners care about.`,
    descriptionMarkdown: `
* Monitor your business credit (Experian, Equifax, FICO SBSS)
* Build your business history
* Manage your cash`,
    logo: navLogo,
    featureImage: navFeature,
    url: 'https://nav.nkwcmr.net/growfunds',
  },
  {
    code: 'quickbooks',
    name: 'QuickBooks',
    pitch:
      'Get QuickBooks Online and QuickBooks Payroll products with an exclusive **discount of 30% off** for 6 months.',
    descriptionMarkdown: `
* Scale your business seamlessly
* Unlock deeper insights
* Work like you have a larger team behind you`,
    logo: quickbooksLogo,
    featureImage: quickbooksFeature,
    url: 'https://quickbooks.partnerlinks.io/amnhod1v9xmj',
  },
  {
    code: 'tailor_brands',
    name: 'Tailor Brands',
    pitch:
      'Establish your entity, set up your online presence, create your website and landing pages with Tailor Brands.',
    descriptionMarkdown: `
* LLC formation
* Business insurance
* Business bank account
* Logo
* Website and Domain name
* Digital business cards and${nonBreakableSpace}more!`,
    logo: tailorBrandsLogo,
    featureImage: tailorBrandsFeature,
    url: 'https://tailorbrands.go2cloud.org/aff_c?offer_id=90&aff_id=8836',
  },
  {
    code: 'google_workspace',
    name: 'Google Workspace',
    pitch:
      'Boost productivity and collaboration with Google Workspace. Get **10% off your first year**!',
    descriptionMarkdown: `
* Professional business email with Gmail
* Secure cloud storage with Google Drive
* Easy collaboration with Docs, Sheets, and Slides
* Integrated Calendar for scheduling`,
    logo: googleWorkspaceLogo,
    featureImage: googleWorkspaceFeature,
    url: 'https://referworkspace.app.goo.gl/354k',
    buttonText: 'Get Offer',
    new: true,
  },
  {
    code: 'coming_soon',
    name: 'Coming soon',
    pitch: 'New Marketplace offers are coming soon!',
    descriptionMarkdown: `
We are working hard to bring you even more amazing deals!

Stay tuned!`,
    logo: comingSoonLogo,
    featureImage: comingSoonFeature,
  },
];

const comingSoonReferral = MARKETPLACE_REFERRALS.find((r) => r.code === 'coming_soon');
const otherReferrals = MARKETPLACE_REFERRALS.filter((r) => r.code !== 'coming_soon');

otherReferrals.sort((a, b) => a.code.localeCompare(b.code));

export const REFERRALS: readonly Referral[] = [
  ...otherReferrals,
  ...(comingSoonReferral ? [comingSoonReferral] : []),
];
